module.exports = __webpack_public_path__ + "img/teraz.c45c2078.png";